import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

// Legacy slices
import budgetReducer from './slices/budgetSlice'
import portfolioReducer from './slices/portfolioSlice'
import debtReducer from './slices/debtSlice'
import realEstateReducer from './slices/realEstateSlice'
import retirementReducer from './slices/retirementSlice'
import cashFlowAllocationReducer from './slices/cashFlowAllocationSlice'
import uiReducer from './slices/uiSlice'
import authReducer from './slices/authSlice'
import notificationsReducer from './slices/notificationsSlice'
import surveyReducer from './slices/surveySlice'
import goalsReducer from './slices/goalsSlice'
import gamificationReducer from './slices/gamificationSlice'

// New Life Planner slices
import lifePlanReducer from './slices/lifePlanSlice'
import timelineReducer from './slices/timelineSlice'
import questionnaireReducer from './slices/questionnaireSlice'
import chatReducer from './slices/chatSlice'

const rootReducer = combineReducers({
  // Legacy slices
  budget: budgetReducer,
  portfolio: portfolioReducer,
  debt: debtReducer,
  realEstate: realEstateReducer,
  retirement: retirementReducer,
  cashFlowAllocation: cashFlowAllocationReducer,
  ui: uiReducer,
  auth: authReducer,
  notifications: notificationsReducer,
  survey: surveyReducer,
  goals: goalsReducer,
  gamification: gamificationReducer,
  
  // New Life Planner slices
  lifePlan: lifePlanReducer,
  timeline: timelineReducer,
  questionnaire: questionnaireReducer,
  chat: chatReducer,
})

const persistConfig = {
  key: 'root',
  version: 2,  // Bumped version for new structure
  storage,
  whitelist: [
    // Legacy
    'budget', 'portfolio', 'debt', 'realEstate', 'retirement', 'cashFlowAllocation', 'survey', 'goals', 'gamification',
    // New Life Planner
    'lifePlan', 'timeline', 'questionnaire', 'chat',
  ],
  blacklist: ['ui', 'auth', 'notifications'],
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  devTools: import.meta.env.DEV,
})

export const persistor = persistStore(store)

// Infer types from the store
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
